import { HomeCtrl } from "./controllers/home";
import { HomeService } from "./services/home";
import { HomeMyOkrs } from "./directives/my-okrs";
import { HomeProgress } from "./directives/progress";
import { HomeScreenComponent } from "./components/home-screen/home-screen.component";
import { HomeTodoComponent } from "./components/home-todo/home-todo.component";

import core from "@gtmhub/core/module";
import reflections from "@gtmhub/reflections/reflections.module";

export default angular
  .module("home", [core, reflections])
  .controller("HomeCtrl", HomeCtrl)
  .service("HomeService", HomeService)
  .component("homeTodo", HomeTodoComponent)
  .directive("homeMyOkrs", HomeMyOkrs.factory())
  .component("homeScreen", HomeScreenComponent)
  .directive("homeProgress", HomeProgress.factory()).name;
